import { render, staticRenderFns } from "./TextDetails.vue?vue&type=template&id=2fb15bce&scoped=true&"
import script from "./TextDetails.vue?vue&type=script&lang=js&"
export * from "./TextDetails.vue?vue&type=script&lang=js&"
import style0 from "./TextDetails.vue?vue&type=style&index=0&id=2fb15bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb15bce",
  null
  
)

export default component.exports